import { get } from "app/utils/axios/kheti";
import { UserResponse } from "../models/diagnosis";
const fetchOrCreateUser = async (
  phone: string,
  name: string
): Promise<UserResponse | null> => {
  try {
    const response = await get<UserResponse>("/user/v1/fetch-or-create-user", {
      phone_number: phone,
      name: name,
    });
    return response;
  } catch (error) {
    return null;
  }
};

export default fetchOrCreateUser;
